//选型模块
import { defineStore } from "pinia";
let corpFlag = window.globalConfig.CorpInfo.CorpFlag;
const keyBySimu = `${corpFlag}_BySimu`;
const keyByParas = `${corpFlag}_ByParas`;
export const useSelect = defineStore("select", {
  state: () => ({
    /**参数选型1 */
    ByParas:JSON.parse(sessionStorage.getItem(keyByParas)) || {},
    /**相似选型*/
    BySimu: sessionStorage.getItem(keyBySimu) || {},

    ByFAN: sessionStorage.getItem("ByFAN") || {},
    // 参数选型(供水)
    BySWParas: sessionStorage.getItem("BySWParas") || {},
  }),
  actions: {
    setByParas(current) {
      sessionStorage.setItem(keyByParas,JSON.stringify(current));
      Object.assign(this.ByParas, current);
    },

    setBySimu(current) {
      sessionStorage.setItem(keyBySimu, JSON.stringify(current));
      Object.assign(this.BySimu, current);
    },

    setBySWParas(current) {
      sessionStorage.setItem("BySWParas", JSON.stringify(current));
      Object.assign(this.BySWParas, current);
    },
    
    clear(key) {
      sessionStorage.remove(key);
    },
  },
});
